class FetchService {
    constructor($http) {
        this.$http = $http;
    }

    getCareType() {
        return this.$http.get('' + WEBSERVICEURL + '/dataagility/api/service.refcode/query?domain=CARE');
    }
}

class AuditprogressController {
    constructor($scope, DTOptionsBuilder, DTColumnBuilder, USER, Constants,
        CONST, materialButtons, datePicker, $http, $rootScope, $location, FunctionService) {

        $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
        this.datatableApi;
        this.user = USER;
        this.name = 'Audit Progress';
        this.episodeValue = '';
        this.specialtyString = '';
        this.TUsers = 0;
        this.TAudited = 0;
        this.TFinalised = 0;
        this.TApproved = 0;
        this.locale = 'en-au';
        this.url = WEBSERVICEURL + '/dataagility/api/service.medicalrecords/audited/?';
        this.initUrl = this.url
            + 'startDate=' + moment().locale(this.locale).subtract(2, 'days').format('L')
            + '&endDate=' + moment().locale(this.locale).subtract(1, 'days').format('L');

        FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(
            function (response) {
              $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
              $scope.vm.functionSettings = response.functionSettings;

              Constants.campusData().then(
                function successCallback(response) {
                  if ($scope.vm.user.role !== 'Administrator' && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
                    let campusOptions = [];
                    if (typeof $scope.vm.user.campus === 'string') {
                      campusOptions = unescape($scope.vm.user.campus).split(','); // tslint:disable-line
                    } else {
                      campusOptions = unescape($scope.vm.user.campus.join()).split(','); // tslint:disable-line
                    }
                    $scope.vm.campusOptions = campusOptions;
                    $scope.vm.campus.selectedCampus = campusOptions;
                  } else {
                    $scope.vm.campusOptions = response;
                  }
                }
              );

              $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
              $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
            }
        );

        materialButtons.render();
        materialButtons.processing();

        jQuery.fn.dataTable.Api.register('sum()', function() {
            return this.flatten().reduce(function(a, b) {
                if (typeof a === 'string') {
                    a = a.replace(/[^\d.-]/g, '') * 1;
                }
                if (typeof b === 'string') {
                    b = b.replace(/[^\d.-]/g, '') * 1;
                }
                return a + b;
            }, 0);
        });

        $scope.drawCallback = function(nRow, aData, index) {
            $scope.vm.TUsers = this.api().column(0).data().count();
            $scope.vm.TOpenForAudit = this.api().column(1).data().sum();
            $scope.vm.TApproved = this.api().column(2).data().sum();
            $scope.vm.TFinalised = this.api().column(3).data().sum();
            $scope.vm.TAudited = this.api().column(4).data().sum();
            $scope.vm.TWIESChange = this.api().column(5).data().sum().toFixed(4);
        };

        $scope.initCallback = function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            // Datatables has finished init
            // Initialise searching
            if ($scope.vm.datatableApi)
                return;

            $scope.vm.datatableApi = this.api();

            // Update column headers even when no data returned
            setDtHeaders($scope.vm.datatableApi);

            // setup search filters
            search();

            // set the table to a fixed height, so it never collapsed up and down
            $('#auditTable').closest('.dataTables_scrollBody').height(300);
        };

        this.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
            headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
            url: $scope.vm.initUrl,
            type: 'GET',
            error: (xhr, error, thrown) => {
              if (thrown == 'Unauthorized') {
                //window.location.replace(window.location.origin + '/login');
                console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
            }
            }
        })
            .withDisplayLength(CONST.TABLEROWS)
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('sAjaxDataProp', '')
            .withOption('bLengthChange', false)
            .withPaginationType('simple_numbers')
            .withOption('rowCallback', function (row, data, index) {
                // Update column headers if data returned
                setDtHeaders($('#auditTable').DataTable());
            })
            .withOption('drawCallback', $scope.drawCallback)
            .withOption('initComplete', $scope.initCallback)
            .withOption('scrollY', '300px')
            .withOption('scrollX', 'auto')
            .withOption('aaSorting', [[0, 'asc']])
            .withOption('dom', '<"wrapper"rt<"table-footer"iBp>>')
            .withButtons([
                {
                    extend: 'print',
                    text: ''
                },
                {
                    extend: 'csvHtml5',
                    text: '',
                    filename: $scope.vm.name + '-' + moment().format('YYYYMMDD-HHmm')
                },
                {
                    extend: 'excelHtml5',
                    text: '',
                    filename: $scope.vm.name + '-' + moment().format('YYYYMMDD-HHmm')
                },
                {
                    text: '',
                    action: function(e, dt, node, config) {
                        dt.ajax.reload();
                    }
                }
            ])
            .withColumnFilter({
                aoColumns: [
                    { type: 'select' },
                    { type: 'number' },
                    { type: 'number' },
                    { type: 'number' }
                ]
        });

        this.dtColumns = [
            DTColumnBuilder.newColumn('PCCLModifiedUser').withTitle('User').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('openForAudit').withTitle('Currently Open for Audit').withOption('defaultContent', '').withClass('mdl-data-table__cell--numeric'),
            DTColumnBuilder.newColumn('totalQueriesApproved').withTitle('Ready for Clinician Review').withOption('defaultContent', '').withClass('mdl-data-table__cell--numeric'),
            DTColumnBuilder.newColumn('totalFinalised').withTitle('Finalised').withClass('mdl-data-table__cell--numeric'),
            DTColumnBuilder.newColumn('totalAudited').withTitle('Audited').withClass('mdl-data-table__cell--numeric'),
            DTColumnBuilder.newColumn('WIESChange').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--numeric')
                .renderWith(function (data, type, full) {
                    return parseFloat(data).toFixed(4);
                })
        ];

        this.careType = {
            selectedCareType: []
        };
        this.careTypeOptions = [];
        this.campus = {
          selectedCampus: []
        };
        this.campusOptions = [];
        this.specialty = {
            selectedSpecialty: []
        };
        this.specialtyOptions = {};

        this.los = {
            selectedLos: []
        };
        this.losOptions = {};

        Constants.getDivisionAndSpecialtyData().then(
          function successCallback(response) {
            $scope.vm.specialtyOptions = response.specialties;
            filterSpecialty('add');
            // Can load divisions if needed??
          }
        );

        this.startDatePicker = {
            input: {
                date: moment().locale(this.locale).subtract(2, 'days').startOf('month'),
                dateFormatted: moment().locale(this.locale).subtract(1, 'days').format('L')
            }
        };
        this.endDatePicker = {
            input: {
                date: moment().locale(this.locale).subtract(1, 'days'),
                dateFormatted: moment().locale(this.locale).subtract(1, 'days').format('L')
            }
        };

        // callbacks for lx-selects and lx-date-picker
        // TODO sort out specialtyCallback/selectCallback
        this.specialtyCallback = specialtyCallback;
        this.selectCallback = selectCallback;
        this.filterCareType = filterCareType;
        datePicker.autoClose($scope);

        function setDtHeaders(table) {
            $(table.column(5).header()).html($scope.vm.episodeValue + ' Change');
        }

        function specialtyCallback(_newValue, _oldValue) {
            $scope.vm.changeData();
        }

        function filterSpecialty(swap) {
            $scope.vm.specialty.selectedSpecialty = [];
            if (swap === 'add') {
                $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
            }
        }

        function filterLos(swap) {
            $scope.vm.losOptions = CONST.LOSSIMPLE;
            $scope.vm.los.selectedLos = [];

            if (swap !== 'minus') {
                angular.forEach(CONST.LOSSIMPLE, function(value, key) {
                    $scope.vm.los.selectedLos.push($scope.vm.losOptions[$scope.vm.losOptions.indexOf(value)]);
                });
            }
        }

        function filterCampus(modifier) {
          $scope.vm.campus.selectedCampus = [];
          if (modifier === 'add') {
            $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
          }
        }

      function convertParam(param) {
            let codes = [];

            if (param.length !== 0) {
                angular.forEach(param, function(value, key) {
                    codes.push(value.code);
                });
                return encodeURIComponent(codes.join());
            } else {
                return '';
            }
        }

        this.changeData = changeData;

        function changeData() {
            if ($scope.vm.datatableApi) {
                var campus = '';
                if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
                  if ($scope.vm.user.role !== 'Administrator' && $scope.vm.campus.selectedCampus.length === 0) {
                    campus = $scope.vm.user.campus;
                  } else {
                    campus = $scope.vm.campus.selectedCampus;
                  }
                } else {
                  campus = $scope.vm.campus.selectedCampus;
                }
                var newUrl = $scope.vm.url
                    + 'startDate=' + $scope.vm.startDatePicker.input.dateFormatted
                    + '&endDate=' + $scope.vm.endDatePicker.input.dateFormatted
                    + '&careType=' + convertParam($scope.vm.careType.selectedCareType)
                    + '&campus=' + encodeURIComponent(campus)
                    + '&specialty=' + encodeURIComponent($scope.vm.specialty.selectedSpecialty)
                    + '&los=' + encodeURIComponent($scope.vm.los.selectedLos);
                $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
            }
        }

        function search() {
            // delete any global searches previously applied
            if ($.fn.dataTable.ext.search.length === 1)
                $.fn.dataTable.ext.search.shift();

            var auditTable = $scope.vm.datatableApi;

            filterSpecialty('minus');
            filterLos('minus');

            // re-draw tabele on datepicker close
            $scope.$on('lx-date-picker__close-start', function(e, id) {
                $scope.vm.changeData();
            });
        }

        $scope.getCareType = function() {
            new FetchService($http, $scope).getCareType().then(function successCallback(response) {
                angular.forEach(response.data, function(value, key) {
                    $scope.vm.careTypeOptions.push(value);
                });
            },
            function errorCallback(response) {
                // $scope.feedback = 'Error loading data';
              if (response.status === 401) {
                window.location.replace(window.location.origin + '/login?logout=true');
              }
            });
        };

        $scope.getCareType();

        function selectCallback(_newValue, _oldValue) {
            $scope.vm.changeData();
        }

        function filterCareType(swap) {
            $scope.vm.careType.selectedCareType = [];

            if (swap !== 'minus') {
                angular.forEach($scope.vm.careTypeOptions, function(value, key) {
                    $scope.vm.careType.selectedCareType.push(value);
                });
            }
        }

        // bind filter swap
        this.filterSwap = filterSwap;

        function filterSwap(thisFilter, thisModifier) {
            switch (thisFilter) {
                case 'specialty':
                    if (thisModifier === 'add') {
                        filterSpecialty('add');
                    } else {
                        filterSpecialty('minus');
                    }
                    break;
                case 'los':
                    if (thisModifier === 'add') {
                        filterLos('add');
                    } else {
                        filterLos('minus');
                    }
                    break;
                case 'campus':
                    if (thisModifier === 'add') {
                      filterCampus('add');
                    } else {
                      filterCampus('minus');
                    }
                    break;
                default:
                    break;
            }
        }

        // bind the datatable instance to an object to monitor loading
        this.dtInstanceCallback = dtInstanceCallback;

        function dtInstanceCallback(dtInstance) {
            $scope.dtInstance = dtInstance._renderer;
        }
    }
}

export default AuditprogressController;



// WEBPACK FOOTER //
// ./client/app/common/reports/auditprogress/auditprogress.controller.js